class JsonContentParse extends CustomHTMLElement {
	constructor() {
		super();

		this.selectors = {
			jsonContent: '.json-content-parse__template',
		};

		this.classes = {
			jsonContent: 'json-content-parse__template',
			isHidden: 'is-hidden',
			flagShowMore: 'collapsible-content__flag-show-more',
		};

		this.data = this.dataset.json && this.dataset.json !== ''
			? JSON.parse(this.dataset.json)
			: null;
		this.dataLimit = this.dataset.limit
			? parseInt(this.dataset.limit)
			: this.data.length > 0
			? parseInt(this.data.length)
			: Object.keys(this.data).length;
		this.arrayOfProperties = this.dataset.properties.split(',');
		this.template = this.querySelector(this.selectors.jsonContent);

		this.addEventListener('shopify:block:select', () => this._parseContent());
		this.addEventListener('shopify:block:deselect', () => this._parseContent());
	}

	connectedCallback() {
		if (this.data) {
			this._parseContent();
		} else {
			// If no data initially, set up a one-time listener
			document.addEventListener('DOMContentLoaded', () => {
				// Check again after content is loaded
				if (this.dataset.json && this.dataset.json !== '') {
					this.data = JSON.parse(this.dataset.json);
					this._parseContent();
				}
			}, { once: true });
		}
	}
	_parseContent() {
		if (this.data.length > 0) {
			let loadMoreMarkup = false;

			this.data.forEach((item, itemIndex) => {
				if (itemIndex < this.dataLimit) {
					const clone = this.template.cloneNode(true);
					const loadMoreButton = this.dataset.showMore && this.dataset.showMore != '' ? parseInt(this.dataset.showMore) : false;
					this.arrayOfProperties.forEach((property) => {
						const element = clone.querySelector(`[data-property-${property.trim()}]`);
						const valueToBeInserted = item[property];

						if (element && valueToBeInserted && valueToBeInserted.length > 0) {
							if (property == 'link') {
								element.href = valueToBeInserted;
							} else {
								element.innerHTML = valueToBeInserted;
							}

							this.handleAttributes(element, this.template, itemIndex);
							element.removeAttribute('data-property-' + property.trim());
						} else if (element) {
							element.remove();
						}
					});

					if (loadMoreButton != false) {
						if (itemIndex === loadMoreButton) {
							clone.classList.add(this.classes.isHidden);
							clone.classList.add(this.classes.flagShowMore);
							loadMoreMarkup = `
								<div class="flex-container flex-dir-row align-center-middle">
									<button aria-expanded="false" class="button button--outline button--text collapsible-content__button-show-more">
									<span class="loader-button__text">${window.themeVariables.strings.generalLoadMore}</span>
								</button>
							</div>
							`;
						} else if (itemIndex > loadMoreButton) {
							clone.classList.add(this.classes.isHidden);
							clone.classList.add(this.classes.flagShowMore);
						}
					}

					this.finishSetup(this, clone, itemIndex);
				}
			});

			if (loadMoreMarkup != false) {
				this.insertAdjacentHTML('beforeend', loadMoreMarkup);
			}
		} else {
			let loadMoreMarkup = false;
			Object.keys(this.data).forEach((key, keyIndex) => {
				if (keyIndex < this.dataLimit) {
					const clone = this.template.cloneNode(true);
					const loadMoreButton = this.dataset.showMore && this.dataset.showMore != '' ? parseInt(this.dataset.showMore) : false;

					this.arrayOfProperties.forEach((property) => {
						const element = clone.querySelector(`[data-property-${property.trim()}]`);

						try {
							const valueToBeInserted = this.data[key][property.trim()];

							if (
								(valueToBeInserted && valueToBeInserted.includes('various narrators')) ||
								(valueToBeInserted && valueToBeInserted.includes('ansamble'))
							) {
								return;
							}

							if (element && valueToBeInserted && valueToBeInserted.length > 0) {
								this.handleAttributes(element, this.template, keyIndex);

								if (this.isImage(valueToBeInserted)) {
									element.innerHTML = `<img src="${valueToBeInserted}" alt="${property.trim()}">`;
								} else if (element.tagName.toLowerCase() === 'input') {
									element.insertAdjacentHTML(
										'afterend',
										`<label class="button button--text" for="${element.id}">${valueToBeInserted}</label>`
									);
									keyIndex == 0 ? (element.checked = true) : (element.checked = false);
								} else {
									element.innerHTML = valueToBeInserted;
								}

								element.removeAttribute('data-property-' + property.trim());
							} else if (
								property.trim().includes('image') &&
								!valueToBeInserted &&
								element.dataset.onErrorPlaceholder &&
								element.dataset.onErrorPlaceholder != ''
							) {
								element.innerHTML = `<img src="${element.dataset.onErrorPlaceholder}" alt="${property.trim()}" loading="lazy">`;
							} else if (element && property.toLowerCase().includes('-')) {
								const subPropertyArray = property.split('-').map((word) => word.toLowerCase());
								const propertiesFromMainObject = Object.keys(this.data[key]);
								const newMainProperty = propertiesFromMainObject.find((property) =>
									subPropertyArray.includes(property.toLowerCase())
								);
								let newValueToBeInserted = this.data[key][newMainProperty];

								if (!newValueToBeInserted) {
									element.remove();
								} else {
									if (Array.isArray(newValueToBeInserted)) {
										newValueToBeInserted = newValueToBeInserted[0];
									}

									subPropertyArray.forEach((subProperty) => {
										const subElement = clone.querySelector(`[data-property-${subProperty.trim()}]`);
										const subValueToBeInserted = newValueToBeInserted[subProperty.trim()];

										if (subElement) {
											if (subValueToBeInserted) {
												subElement.innerHTML = subValueToBeInserted;
											}
										}
									});
								}
							} else if (element) {
								element.remove();
							}
						} catch (error) {
							if (element) {
								element.remove();
							}

							console.warn(`Property ${property.trim()} not found in object ${key}`);
						}
					});

					if (loadMoreButton != false) {
						if (keyIndex === loadMoreButton) {
							clone.classList.add(this.classes.isHidden);
							clone.classList.add(this.classes.flagShowMore);
							loadMoreMarkup = `
								<div class="flex-container flex-dir-row align-center-middle">
									<button aria-expanded="false" class="button button--outline button--text collapsible-content__button-show-more">
									<span class="loader-button__text">${window.themeVariables.strings.generalLoadMore}</span>
								</button>
							</div>
							`;
						} else if (keyIndex > loadMoreButton) {
							clone.classList.add(this.classes.isHidden);
							clone.classList.add(this.classes.flagShowMore);
						}
					}

					this.finishSetup(this, clone, keyIndex);
				}
			});
		}

		this.template.remove();
	}

	handleAttributes(element, template, keyIndex) {
		if (element.dataset.moveOutside === 'true') {
			template.insertAdjacentElement('beforebegin', element);
		}

		if (element.dataset.index === 'insert') {
			element.dataset.index = keyIndex;
		}

		if (element.id != undefined && element.id != '') {
			element.id = element.id + keyIndex;
		}
	}

	finishSetup(that, clone, itemIndex) {
		if (clone.dataset.index === 'insert') {
			clone.dataset.index = itemIndex;
		}

		clone.classList.remove(this.classes.jsonContent);
		that.appendChild(clone);
	}

	isImage(url) {
		return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
	}
}

window.customElements.define('json-content-parse', JsonContentParse);
